
<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Print Preview Error</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">Your browser is blocking popups from this site.  Please enable popups to open the print preview.</div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="retry()">Retry</button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>